import React from 'react';
import { Alert } from '../../../../../CommonComponents/OPL/Alert/Alert';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalFooter } from '../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { ModalHeader } from '../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { IntegrationDTO } from '../../api/useIntegrationsSettingsQuery';
import { IntegrationInfo } from '../IntegrationInfo/IntegrationInfo';

import { useRiskalyze } from './useRiskalyze';

const website = 'https://www.riskalyze.com/';
const helpUrl =
  'https://orionadvisorservices.my.site.com/OrionSupportApp/s/article/Orion-Planning-Riskalyze-Integration';

interface Props {
  integration: IntegrationDTO;
  onClose(): void;
}

export const Riskalyze = ({ integration, onClose }: Props) => {
  const { connectRiskalyze, error: connectError, isLoading: isConnecting } = useRiskalyze();

  return (
    <Modal isOpen onRequestClose={onClose} aria={{ labelledby: 'modal-header' }}>
      <ModalHeader as="h2" id="modal-header">
        {integration.Label}
      </ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <IntegrationInfo integration={integration} website={website} helpUrl={helpUrl} />

        {connectError && (
          <Alert
            mb="8"
            variant="error"
            message="There was an issue completing your request. Please try again later."
          />
        )}

        <Text>
          Import your model portfolios from Riskalyze into Orion Planning. Once imported, you can
          view, edit and reorder your portfolios in Riskalyze and then re-import them via this page.
          You cannot edit your profiles through Orion Planning when using Riskalyze&apos;s
          portfolios.
        </Text>
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button
          ml="8"
          onClick={() => {
            connectRiskalyze();
          }}
          disabled={isConnecting}
          isLoading={isConnecting}
          rightIcon="fa fa-download"
        >
          Import {integration.Label} Portfolios
        </Button>
      </ModalFooter>
    </Modal>
  );
};
